import React from 'react';
import { Card, CardHeader, CardBody, Table, Button, Badge } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { FLUSH_ENTITY_CACHE } from '@api';

function fmtBytes(n) {
  if (n == null) return '—';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

export default function CacheSystemPanel({ cache, onDone }) {
  const [flush, { loading }] = useMutation(FLUSH_ENTITY_CACHE, {
    onCompleted: (d) => { toast.success(d?.flushEntityCache?.message || 'Flushed'); onDone && onDone(); },
    onError: (e) => toast.error(e.message),
  });

  return (
    <Card>
      <CardHeader style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <strong>Cache (Redis)</strong>
        <Badge color={cache?.redisConnected ? 'success' : 'danger'}>
          {cache?.redisConnected ? 'connected' : 'DOWN'}
        </Badge>
        <span style={{ marginLeft: 'auto' }}>
          <Button size='sm' color='danger' disabled={loading} onClick={() => {
            if (!window.confirm('Flush PropertyEntityCache for ALL cities? Next request will rebuild from DB.')) return;
            flush({ variables: { all: true } });
          }}>Flush All Cities</Button>
        </span>
      </CardHeader>
      <CardBody>
        <div style={{ marginBottom: 12, fontSize: 15 }}>
          <strong>Memory:</strong> {fmtBytes(cache?.memoryBytes)}
        </div>
        <Table size='sm' className='mb-0'>
          <thead>
            <tr><th>Prefix</th><th>Keys</th><th>Description</th></tr>
          </thead>
          <tbody>
            {(cache?.keyCounts || []).map((k) => (
              <tr key={k.prefix}>
                <td><code>{k.prefix}:*</code></td>
                <td>{k.count}</td>
                <td style={{ fontSize: 13, color: '#666' }}>{describe(k.prefix)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
}

function describe(prefix) {
  switch (prefix) {
    case 'ec:s': return 'Static property data (address, coords, amenities)';
    case 'ec:i': return 'Image URLs';
    case 'ec:p': return 'Pricing (min/max price, sqft, floor plans)';
    case 'ec:m': return 'Per-city manifest (property ID list)';
    case 'ec:cutoff': return 'Per-city delta sync cutoff timestamp';
    default: return '';
  }
}
